'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:invoke:version-compare');
}

/**
 * compare version number
 *
 * @private
 * @param {String} a
 * @param {String} b
 * @return {Number} -1 is <, 0 is =, 1 is >
 *
 * @example
 *  compare('6.0', '6.0.1'); // -1
 *  compare('6.0', '5.9'); // 1
 *  compare('5.9.2', '5.9.2'); // 0
 */
var compare = function(a, b) {
    var pa = String(a).split('.');
    var pb = String(b).split('.');
    var len = Math.min(pa.length, pb.length) + 1;

    if (process.env.NODE_ENV !== 'production') {
        debug('a is %j', pa);
        debug('b is %j', pb);
    }

    for (var i = 0; i < len; ++i) {
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) {
            return 1;
        } else if (nb > na) {
            return -1;
        } else if (!isNaN(na) && isNaN(nb)) {
            return 1;
        } else if (isNaN(na) && !isNaN(nb)) {
            return -1;
        }
    }
    return 0;
};

module.exports = compare;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/invoke/version-compare.js
// module id = 94
// module chunks = 0